/**
 * UI language when nothing is saved or detected: the preferred target when it is synced, otherwise the first
 * target; the source locale only while no target exists at all.
 */
export const pickDefaultLanguage = (languages: readonly string[], preferred: string, source: string): string => {
  if (languages.includes(preferred)) {
    return preferred;
  }

  return languages[0] ?? source;
};
